module.exports = __webpack_public_path__ + "static/img/banner09.6337bdd0.png";